import AnnouncementBar from "./components/home/AnnouncementBar";
import Navbar from "./components/home/Navbar";
import Hero from "./components/home/Hero";
import Ticker from "./components/home/Ticker";
import AudienceSection from "./components/home/AudienceSection";
import ServicesSection from "./components/home/ServicesSection";
import GallerySection from "./components/home/GallerySection";
import ConvertSection from "./components/home/ConvertSection";
import TestimonialsSection from "./components/home/TestimonialsSection";
import AboutSection from "./components/home/AboutSection";
import ContactSection from "./components/home/ContactSection";
import Footer from "./components/home/Footer";

export default function App() {
  return (
    <main>
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <Ticker />
      <AudienceSection />
      <ServicesSection />
      <GallerySection />
      <ConvertSection />
      <TestimonialsSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
